import React from 'react'
import { connect } from 'react-redux'
import { sendTextToApi, sentText } from '../actions/text'
import { Redirect } from 'react-router-dom'
import './submit-text.css'

export class SubmitText extends React.Component {
	constructor(props) {
		super(props)

		this.title = ''
		this.body = ''
		this.description = ''
	}

	onSubmit(e, title, body, description) {
		e.preventDefault()

		const text = {
			title: title.value,
			body: body.value,
			authorId: this.props.uid,
			authorName: this.props.currentUser.username,
			description: description.value
		}
		
		this.props.dispatch(sendTextToApi(text))
		this.props.dispatch(sentText(true))
	}
	
	render(){

		if (!this.props.loggedIn) {
            return <Redirect to="/" />
        }
        if (this.props.sentText) {
        	return <Redirect to="/" />
        }
        

		return(
				<div className='row'>
					<div className='view-form col-8'>
						<input className='title' name='title' placeholder='Title' ref={ input => this.title = input }/>
						<textarea className='description col-12' placeholder='Give a brief description of your paper' ref={ input => this.description = input } />
						<textarea className='form col-12' placeholder='Write your paper here' ref={ input => this.body = input } />
						<div>
							<button onClick={ e => { this.onSubmit(e, this.title, this.body, this.description) } } className='submit'>Submit</button>
						</div>
					</div>
				</div>
		)
	}
}

const mapStateToProps = state => ({
	sentText: state.text.sentText,
	loggedIn: state.auth.currentUser !== null,
	currentUser: state.auth.currentUser,
	uid: state.auth.uid,
	initialText: state.text.initialText,
	text: state.text.text
})

export default connect(mapStateToProps)(SubmitText)


// WEBPACK FOOTER //
// ./src/components/submit-text.js